var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-selector"},[_c('DatePicker',{class:_vm.inputClasses,attrs:{"value":_vm.selectedDate,"config":_vm.options},on:{"dp-change":function($event){return _vm.selectDate($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }